import type { RadioButtonDesignTokens } from '@primeuix/themes/types/radiobutton';

export const radioButtonPreset: RadioButtonDesignTokens = {
  root: {
    focusRing: {
      color: '{nspSky.300}',
      shadow: 'none',
      offset: '0',
    },
  },

  colorScheme: {
    dark: {
      root: {
        background: '{nspSlate.800}',
        borderColor: '{nspSlate.200}',
        hoverBorderColor: '{nspSlate.200}',
        checkedBackground: '{nspSky.500}',
        checkedBorderColor: '{nspSky.500}',
        checkedHoverBackground: '{nspSky.500}',
        checkedHoverBorderColor: '{nspSky.300}',
        invalidBorderColor: '{nspCrimson.400}',
        disabledBackground: '{nspSlate.800}',
        checkedDisabledBorderColor: '{nspSlate.200}',
      },
      icon: {
        checkedColor: '{nspSlate.0}',
        checkedHoverColor: '{nspSlate.0}',
      },
    },
    light: {
      root: {
        background: '{nspSlate.0}',
        borderColor: '{nspMist.300}',
        hoverBorderColor: '{nspOcean.400}',
        checkedBackground: '{nspOcean.400}',
        checkedBorderColor: '{nspOcean.400}',
        checkedHoverBackground: '{nspOcean.300}',
        checkedHoverBorderColor: '{nspOcean.300}',
        invalidBorderColor: '{nspCrimson.400}',
        disabledBackground: '{nspSlate.0}',
        checkedDisabledBorderColor: '{nspMist.300}',
      },
      icon: {
        checkedColor: '{nspSlate.0}',
        checkedHoverColor: '{nspSlate.0}',
      },
    },
  },
};
